var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 41C6 41.8284 6.67157 42.5 7.5 42.5H27.5663H41.5C42.3284 42.5 43 41.8284 43 41V33.7783C42.8846 33.7129 42.7761 33.631 42.6779 33.5326L37.7999 28.6465L32.1358 35.3988C31.6034 36.0335 30.6573 36.1164 30.0226 35.584C29.931 35.5072 29.8509 35.4217 29.7825 35.3299C29.686 35.2696 29.5949 35.1974 29.5113 35.1131L17.9911 23.504L6 35.495V41ZM30.8775 32.2308L36.5545 25.4631C36.8249 25.1407 37.2184 24.9467 37.6388 24.9285C38.0592 24.9103 38.4679 25.0695 38.7653 25.3673L43 29.6091V26.4838V7C43 6.17157 42.3284 5.5 41.5 5.5H7.5C6.67157 5.5 6 6.17157 6 7V31.2524L16.9345 20.3179C17.2165 20.0359 17.5992 19.8778 17.998 19.8786C18.3969 19.8793 18.779 20.0389 19.0599 20.322L30.8775 32.2308ZM3 34.8737V41C3 43.4853 5.01472 45.5 7.5 45.5H27.5663H41.5C43.9853 45.5 46 43.4852 46 41V26.4838V7C46 4.51472 43.9853 2.5 41.5 2.5H7.5C5.01472 2.5 3 4.51472 3 7V34.8737ZM35.8916 15.8203C35.8916 17.9964 34.1348 19.7605 31.9676 19.7605C29.8005 19.7605 28.0437 17.9964 28.0437 15.8203C28.0437 13.6443 29.8005 11.8802 31.9676 11.8802C34.1348 11.8802 35.8916 13.6443 35.8916 15.8203Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b3ed2395d72b5c5e43c3914d92e1e229.svg";
export { ForwardRef as ReactComponent };